export default {"src":"/_booking/_next/static/media/chevron-down.af8a8e24.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};